export const SLUG_REGEX = /^[a-z0-9-]{3,40}$/;

/** Turn a free-form name into a slug candidate that matches SLUG_REGEX. */
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);
}

export function isValidSlug(value: string): boolean {
  return SLUG_REGEX.test(value);
}
